import strings from '../../../../Localization/Localization';

let scheduleDate = {
  fieldKey: "schedule_date",
  type: "date",
  label: strings.form.service.transition.scheduleTermination.scheduleDate.label,

  min: () => {
    let today = new Date();
    let year = String(today.getFullYear());
    let month = String(today.getMonth()+1).padStart(2, "0");
    let date = String(today.getDate()).padStart(2, "0");
    console.log(year+'-'+month+'-'+date);
    return year+'-'+month+'-'+date
  },

  validators: [
    {
      id: 'assertEmpty',
      type: 'notEmptyOrNull',
      invalidFeedback: strings.form.service.transition.scheduleTermination.scheduleDate.invalid.assertEmpty,
      defaultValue: false
    },
  ]
}

export const form = {
  formKey: "scheduleTermination",
  fields: [
    scheduleDate
  ]
}
